import {
  Component, Vue,
} from 'vue-property-decorator';
import WithRender from './governmental-persona.html';
import BasePersona from '../base-persona/BasePersona';
import { Inject } from 'vue-di-container';
import SharedDataService from '@/modules/shared/services/sharedDataService';

@WithRender
@Component({
  components: {
    BasePersona,
  },
})
export default class GovernmentalPersona extends Vue {
  @Inject()
  public sharedDataService!:SharedDataService;

  public get target() {
    return [this.sharedDataService.Personas.GOVERNMENTAL];
  }
}
